'use client'
export { ErrorPage as default } from '@/components/ErrorPage'
